import React, {useState, useEffect} from 'react';
import { Button, ButtonGroup, Row, Col } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from '../../hooks'
import {TOKENS, SOL} from '../../constants/constants'
import { setBetAmount } from "../../redux/reducers/storageSlice"
import {isMobile} from 'react-device-detect';

const Amounts: React.FC = () => {
    
    const dispatch = useAppDispatch();
    const mode = useAppSelector(state => state.storage.mode)
    const token = useAppSelector(state => state.storage.token)
    const betMultiplier = useAppSelector(state => state.storage.betMultiplier)
    const betAmount = useAppSelector(state => state.storage.betAmount)
    const [selector, setSelector] = useState(SOL)
    let amountsComp = [];
    const selectBetAmount = (bet: any) => {
        dispatch(setBetAmount(bet))
    }   
    // console.log(mode)
    useEffect(() => {
        if (mode =="Token") {
            setSelector(TOKENS[token]["betConstraints"])
        } else {
            setSelector(SOL);
        }
    }, [mode])
    useEffect(() => {
        if (mode =="Token") {
            setSelector(TOKENS[token]["betConstraints"])
        } else {
            setSelector(SOL);
        }
    }, [])    
    // console.log(selector)
    let foundMultiplier = selector.find(element => element.value == betMultiplier)
    // console.log(foundMultiplier)
    // console.log(selector)
    // console.log(betMultiplier)
    let measurement = null;
    if (isMobile){
        measurement = 3
        if (foundMultiplier.amounts.length == 6) measurement = 4
        if (foundMultiplier.amounts.length == 5) measurement = null
        if (foundMultiplier.amounts.length == 8) measurement = 3
    }

    // measurement    
    amountsComp = foundMultiplier.amounts.map((amount, index) => (
        <Col xs={measurement} style={{padding: 1, margin: 0}}><Button key={index+1} variant="light" style={{width: '100%', border: "2px solid black"}} active={betAmount ==amount} onClick={() => {selectBetAmount(amount)}}><h5 style={{marginBottom: 0, whiteSpace: "break-spaces", color: "black"}}>{`${amount}\n${token}`}</h5></Button></Col>
    ))

    return (
        <Row style={{display: "flex", justifyContent: 'center'}}>
            
            {amountsComp}
        </Row>
    );
}

export default Amounts;